import { SubfolderView } from '@/features/AssetDetailView/FolderDetailView/SubfolderView';
import { createFileRoute } from '@tanstack/react-router';

type SubfolderSearchParams = {
    selectedAD?: string;
    filter?: string;
    c006Filter?: string;
    b013Filter?: string;
    h001Filter?: string;
    h002Filter?: string;
    c007Filter?: string;
    // Reserved and currently unwired; kept for a future infinite/virtualised table query.
    page?: number;
    selectedRow?: string;
    // B013's selected report and sheet tab.
    report?: number;
    sheet?: string;
};

function parseOptionalFiniteNumber(value: unknown): number | undefined {
    if (value === undefined || value === null || value === '') return undefined;
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
}

export function validateSubfolderListSearch(
    search: Record<string, unknown>,
): SubfolderSearchParams {
    return {
        selectedAD: typeof search.selectedAD === 'string' ? search.selectedAD : undefined,
        filter: typeof search.filter === 'string' ? search.filter : undefined,
        c006Filter: typeof search.c006Filter === 'string' ? search.c006Filter : undefined,
        b013Filter: typeof search.b013Filter === 'string' ? search.b013Filter : undefined,
        h001Filter: typeof search.h001Filter === 'string' ? search.h001Filter : undefined,
        h002Filter: typeof search.h002Filter === 'string' ? search.h002Filter : undefined,
        c007Filter: typeof search.c007Filter === 'string' ? search.c007Filter : undefined,
        page: parseOptionalFiniteNumber(search.page),
        selectedRow: typeof search.selectedRow === 'string' ? search.selectedRow : undefined,
        report: parseOptionalFiniteNumber(search.report),
        sheet: typeof search.sheet === 'string' ? search.sheet : undefined,
    };
}

export const Route = createFileRoute(
    '/asset_collection/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/',
)({
    component: SubfolderView,
    validateSearch: validateSubfolderListSearch,
});
